import { ActionType } from "./flux";
import { LanguagePackKeys } from "../../../../../../translations";

export const groupActionsTranslationKeys = (
    new Map<ActionType, LanguagePackKeys>()
        .set(ActionType.AddTags, 'vehicle.group_actions.action_title_add_tags')
        .set(ActionType.RemoveTags, 'vehicle.group_actions.action_title_remove_tags')
        .set(ActionType.SetTimezone, 'vehicle.group_actions.action_title_set_timezone')
        .set(ActionType.SetPressure, 'vehicle.group_actions.action_title_set_pressure')
        .set(ActionType.SetTemperature, 'vehicle.group_actions.action_title_set_temperature')
);


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/BatchEdit/groupEditNames.ts